module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('span', {
    attrs: {
      "id": "first"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/firm-intro"
    }
  }, [_vm._v("关于我们")])], 1), _vm._v(" "), _c('span', {
    staticClass: "middle"
  }, [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("联系我们")])], 1), _vm._v(" "), _c('span', {
    staticClass: "last"
  }, [_c('router-link', {
    attrs: {
      "to": "/join-us/market"
    }
  }, [_vm._v("诚聘英才")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-67213176!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/footer/HomeAboutUs.vue
// module id = 155
// module chunks = 1